<template>
  <div class="block-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="85px">
        <el-form-item label="资源:" prop="resource">
            <base-upload
                class="upload"
                :cover="params.resource"
                :action="action"
                :wSize="180"
                :hSize="120"
                :width="'180px'"
                :height="'120px'"
                @successCallback="handleAvatarSuccess">
              </base-upload>
        </el-form-item>
        <el-form-item label="类型:" prop="type">
          <el-select placeholder="类型" size="small" clearableb v-model="params.type">
            <el-option key="bg" label="背景图" value="bg"></el-option>
            <el-option key="avatar" label="头像" value="avatar"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      type: '',
      action: baseConfig.baseServerUrl + '/agent/upload/static',
      params: {
        type: '',
        resource: '',
      },
      rules: {
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' },
        ],
        resource: [
          { required: true, message: '请上传资源', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.type === 'add') {
            this.addResource()
          } else {
            this.editResource()
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        number: undefined,
        sortNumber: undefined,
        desc: '',
        imgUrl: '',
      }
      this.$refs['form'].resetFields()
    },
    // 打开限制弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑奖章'
        this.params.number = data.number
        this.params.sortNumber = data.sortNumber
        this.params.desc = data.desc
        this.params.imgUrl = data.imgUrl
        this.id = data.ID
      } else {
        this.title = '新增奖章'
      }

    },
    // 新增
    addResource() {
      API.addResource(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit('handlerClose')
        } else if (res.code === 5002) {
          this.$message.error('添加失败,已有该类型IP限制！')
        } else {
          this.$message.error('添加失败')
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 编辑限制
    editResource() {
      let form = Object.assign({}, this.params, {
        Ip: this.params.ip.split(','),
        id: this.id
      })
      delete form.ip
      API.updResource(form).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerClose')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.resource = res.data.coverImg
    },
  }
}
</script>

<style lang="scss" >
.block-box {
  .el-input--small {
    width: 200px;
  }
  .el-select {
    width: 150px !important;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
